import { useSubscription } from './useSubscription';

/**
 * Returns whether the current tutor can use an early-access module.
 * The admin feature toggle is the gate — cancelled/expired tutors can still
 * use a module once it has been enabled for them.
 */
export function useFeature(featureId: string): {
  enabled: boolean;
  loading: boolean;
} {
  const { subscription, loading } = useSubscription();
  const enabledFeatures = subscription?.subscription?.enabledFeatures || [];

  return {
    enabled: enabledFeatures.includes(featureId),
    loading,
  };
}
